import _ from 'lodash/fp'
import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { actions, types } from '../reducers/holesTexts'

import { apolloClient } from '@fe/business/src/apollo'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

const HOLE_TEXTS_QUERY = gql`
  query HoleTexts($holeId: ID!) {
    holeTexts(holeId: $holeId) {
      groupText
      trackingGroupId
    }
  }
`

export function * loadHolesTextsEffect (holeId) {
  try {
    const result = yield call([apolloClient, apolloClient.query], {
      query: HOLE_TEXTS_QUERY,
      variables: { holeId },
      fetchPolicy: 'network-only'
    })
    const holeTexts = _.getOr([], 'data.holeTexts', result)
    return holeTexts.map(({ groupText, trackingGroupId }) => ({
      group_text: groupText,
      tracking_group_id: trackingGroupId
    }))
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * loadHolesTextsFlow ({ payload: holeId }) {
  const textArray = yield call(loadHolesTextsEffect, holeId)
  yield put(actions.loadRequestDone())

  if (textArray.error) {
    yield put(actions.loadError(textArray))
  } else {
    yield put(actions.loadSuccess({ holeId, textArray }))
  }
}

export default function * () {
  return yield all([
    takeLatest(types.LOAD_REQUEST, loadHolesTextsFlow)
  ])
}
